import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import translationEN from '../i18n/en/translations.json';
import translationDE from '../i18n/de/translations.json';
import translationHR from '../i18n/hr/translations.json';

const resources = {
    en: {
        translation: translationEN
    },
    de: {
        translation: translationDE
    },
    hr: {
        translation: translationHR
    }
};

export const languageToUse = () => {
    if (localStorage.getItem('i18nextLng') === null) {
        return "en";
    }
    return String(localStorage.getItem('i18nextLng'));
}

i18n.use(LanguageDetector).use(initReactI18next).init({
    debug: false,
    resources,
    lng: languageToUse(),
    fallbackLng: "en",
    keySeparator: false,
    interpolation: {
        escapeValue: false
    },
    returnObjects: true
});

export default i18n;